import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import ArrowBack from '@material-ui/icons/ArrowBack';
import FileCopyIcon from '@material-ui/icons/FileCopy';
//import CopyButton from './CopyButton'
//import PropTypes from 'prop-types';
import Print from '@material-ui/icons/Print';
import copy from 'copy-to-clipboard';
import React, { useEffect, useRef, useState } from 'react';
import { CreateButton, EditButton, ShowController, ShowView, useShowController } from 'react-admin';
//import Imprimer from './Imprimer';
import { Link } from "react-router-dom";
import { useReactToPrint } from 'react-to-print';
import Segment from '../communs/Segment.js';



/*
const suppSpaceStyle={
        marginTop:0,
        marginBottom:0,
        paddingTop:0,
        paddingBottom:0,
};

var record=null;
var ref=null;
*/

var infos='';

//var trans_code=null;
const ShowDepense=(props) => {

    const [print, setPrint] = useState(true);
    const [titre, setTitre] = useState(true);
    const [fullname, setFullname] = useState('');

    const { record } = useShowController(props);
    const componentRef = useRef();

  useEffect(() => {
    setFullname(localStorage.getItem('fullname'));
    
}, []);

 const copie=(data)=>{
    //                   "Montant : "+data.trans_amount+" €\n"+
     infos="Code : "+data.trans_code+"\n"+
                  "Dest : "+data.infos_dest+"\n"+
                   "Retrait : "+data.trans_amount+' '+data.trans_devise+"\n"+
                    data.trans_ag_dest+"\n"+
                    "Date : "+data.post_date+"\n"
                   ;
    copy(infos);
}

/*
impression(){
    this.setState({print:false}, () => {});
    //console.log(this.state.print);
}

function impression(){
    alert(JSON.stringify(record));
}
*/
const details=()=>{
    setPrint(false);
}

const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: titre
});
const PostShowActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
            <Button
                label="Copier"
                color="primary"
                onClick={()=>copie(data)}
            >
            <FileCopyIcon />
            </Button>

            <Button color="primary" onClick={handlePrint} label="Imprimer"><Print /></Button>

            <CreateButton basePath={basePath} />
        {data.status==='ATTENTE' ? <EditButton basePath={basePath} record={data} />:null}
        <Button component={Link} to={basePath} label="Retour" color="primary" ><ArrowBack/></Button>

    </CardActions>
);

    return (

        <ShowController {...props}>

            
                {controllerProps => 
                    <ShowView title={'Détails dépense : '+fullname} {...props} actions={<PostShowActions />} {...controllerProps}>
                        {controllerProps.record && print? 


               <Segment ref={componentRef}  tiket={true} code={controllerProps.record.code} datas={
                [
                    {id:'titre',label:'Titre',name:controllerProps.record.titre},
                    {id:'montant',label:'Montant',name:controllerProps.record.montant+' '+controllerProps.record.devise},
                    {id:'dep_created_date',label:'Date création',name:controllerProps.record.dep_created_date},
                    {id:'dep_last_modified_date',label:'Date revue',name:controllerProps.record.dep_last_modified_date},
                    {id:'status',label:'Status dépense',name:controllerProps.record.status},
                    {id:'created_by_name',label:'Crée par',name:controllerProps.record.created_by_name},
                    {id:'commentaire',label:'Commentaire',name:controllerProps.record.commentaire},


                  ]
                } />

                :
                null
   
            }
                    </ShowView>
                }
            
           </ShowController>
        );
        
   

    


}

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    flexDirection: 'column'
};

export default ShowDepense;
